import { Dialog as KobalteDialog } from "@kobalte/core/dialog"
import type { ParentProps } from "solid-js"
import { mergeProps, Show } from "solid-js"
import { Icon } from "@/designSystem/components/icon"
import { Text } from "@/designSystem/components/text"
import { Box } from "./box"
import {
  type ContentVariants,
  closeButtonClass,
  contentClass,
  descriptionClass,
  footerClass,
  overlayClass,
  titleClass,
} from "./dialog.css"

type ModalDialogProps = ParentProps & {
  open: boolean
  onOpenChange: (isOpen: boolean) => void
  title?: string
  description?: string
  footer?: ParentProps["children"]
} & ContentVariants

export function Dialog(nProps: ModalDialogProps) {
  const props = mergeProps({ size: "small" } satisfies ContentVariants, nProps)

  return (
    <KobalteDialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      modal={true}
    >
      <KobalteDialog.Portal>
        <KobalteDialog.Overlay class={overlayClass} />
        <KobalteDialog.Content class={contentClass({ size: props.size })}>
          <KobalteDialog.CloseButton class={closeButtonClass}>
            <Icon name="x" size="24" />
          </KobalteDialog.CloseButton>
          <Box gap="24">
            <Show when={props.title}>
              {title => (
                <Text fontSize="l" fontWeight="500" class={titleClass}>
                  {title()}
                </Text>
              )}
            </Show>
            <Show when={props.description}>
              {description => (
                <Text fontSize="m" color="sand700" class={descriptionClass}>
                  {description()}
                </Text>
              )}
            </Show>
            {props.children}
            <Show when={props.footer}>
              {footer => <div class={footerClass}>{footer()}</div>}
            </Show>
          </Box>
        </KobalteDialog.Content>
      </KobalteDialog.Portal>
    </KobalteDialog>
  )
}
